import { Box, Button, ButtonProps, CircularProgress } from "@mui/material";
import React, { forwardRef, useImperativeHandle } from "react";

export default forwardRef((props: ButtonProps, ref: any) => {
  const [loading, setLoading] = React.useState(false);

  useImperativeHandle(ref, () => ({
    onClick() {
      handleButtonClick({} as any);
    },
  }));

  const handleButtonClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!props.onClick) {
      return;
    }
    try {
      setLoading(true);
      await props.onClick(e);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      className={props.className}
      sx={{ position: "relative", display: "inline-block" }}
    >
      <Button
        {...props}
        variant={props.variant || "contained"}
        className={`initial-text ${props.className || ""}`}
        color={props.color}
        fullWidth={props.fullWidth}
        disabled={props.disabled || loading}
        onClick={handleButtonClick}
      >
        {props.children}
      </Button>

      {loading && (
        <CircularProgress
          size={24}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      )}
    </Box>
  );
});
